import { render, staticRenderFns } from "./ReachTicket.vue?vue&type=template&id=bf37fc72&scoped=true&"
import script from "./ReachTicket.vue?vue&type=script&lang=js&"
export * from "./ReachTicket.vue?vue&type=script&lang=js&"
import style0 from "./ReachTicket.vue?vue&type=style&index=0&id=bf37fc72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf37fc72",
  null
  
)

export default component.exports